// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/about 9.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Aboute_abooute__8Kayc {
  width: 100%;
}

.Aboute_aboute-section__8ewhH {
  width: 100%;
  background-color: #1e1e1e;
}

.Aboute_bg__rstTK {
  width: 100%;
  height: 230vh;
  opacity: 0.3;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.Aboute_aboute-container__UDnOj {
  width: 80%;
  background-color: #1e1e1e;
  margin: auto;
}

.Aboute_header__zXOM0 {
  font-size: 96px;
  font-weight: 700;
  line-height: 100%;
  color: white;
  font-family: "Roboto", sans-serif;
  margin-top: 200px;
  margin-bottom: 200px;
}

.Aboute_paragraph__x6NEY {
  font-size: 36px;
  font-weight: 700;
  line-height: 100%;
  color: white;
  font-family: "Roboto", sans-serif;
}

.Aboute_childs-sections__XB35c {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}

.Aboute_childs-sections__XB35c div {
  width: 400px;
  height: 182px;
  background-color: white;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  border-radius: 16px;
  transition: transform 1.2s ease, box-shadow 1.2s ease;
}

.Aboute_childs-sections__XB35c div:hover,
.Aboute_childs-sections__XB35c div:focus,
.Aboute_childs-sections__XB35c div:active {
  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);
  transform: scale(1.2);
}

.Aboute_childs-sections__XB35c div p:hover {
  color: #191A1A;
  cursor: pointer;
}

.Aboute_childs-sections__XB35c div p {
  color: #4C6D59;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  line-height: 100%;
  width: 90%;
  font-weight: 500;
}

.Aboute_paragraphs-section__62vxi {
  width: 100%;
  margin-top: 150px;
}

.Aboute_paragraphs-section__62vxi h6 {
  font-size: 32px;
  font-weight: 700;
  color: white;
  font-family: "Roboto", sans-serif;
}

.Aboute_paragraphs-section__62vxi h2 {
  font-size: 32px;
  font-weight: 500;
  color: white;
  font-family: "Roboto", sans-serif;
}

.Aboute_paragraphs-section__62vxi p {
  font-size: clamp(23px, 6vw, 22px);
  font-weight: 500;
  line-height: 1.2;
  color: white;
  width: 50%;
  font-family: "Roboto", sans-serif;
  text-align: justify;
}

.Aboute_goals__On1aT {
  margin-top: 200px;
  display: flex;
  flex-wrap: wrap;
}

.Aboute_img__KQmE6 {
  width: 512px;
  height: 423px;
  background-image: url("https://i.imgur.com/S0Ar7tC.jpeg");
  background-repeat: no-repeat;
  background-size: contain;
}

.Aboute_texts__dJO0u {
  max-width: 820px;
  margin-bottom: 110px;
}

.Aboute_texts-two__OX7hW {
  margin-bottom: 100px;
}

.Aboute_texts__dJO0u h2 {
  color: white;
  font-weight: 500;
  font-size: 32px;
  margin-bottom: 40px;
  font-family: "Roboto", sans-serif;
}

.Aboute_texts__dJO0u p {
  color: white;
  font-weight: 400;
  font-size: clamp(23px, 6vw, 22px);
  text-align: justify;
  font-family: "Roboto", sans-serif;
}

.Aboute_texts-two__OX7hW h2 {
  color: white;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Aboute_texts-two__OX7hW p {
  color: white;
  font-weight: 500;
  font-size: clamp(22px, 6vw, 22px);
  line-height: 1.4;
  font-family: "Roboto", sans-serif;
  width: 50%;
  text-align: justify;
}

@media screen and (max-width: 768px) {
  .Aboute_childs-sections__XB35c div {
    width: 90%;
  }
  .Aboute_paragraphs-section__62vxi p,
  .Aboute_texts-two__OX7hW p {
    width: 90%;
  }
  .Aboute_img__KQmE6 {
    width: 90%;
    height: 250px;
  }
  .Aboute_texts__dJO0u {
    width: 90%;
  }
  .Aboute_header__zXOM0 {
    font-size: 42px;
  }
  .Aboute_paragraph__x6NEY {
    font-size: 32px;
  }
  .Aboute_paragraphs-section__62vxi p {
    font-size: 18px;
  }
  .Aboute_texts__dJO0u p {
    font-size: 18px;
  }
  .Aboute_texts-two__OX7hW p {
    font-size: 18px;
  }
}
@media screen and (max-width: 1586px) {
  .Aboute_texts__dJO0u {
    width: 500px;
  }
}
@media screen and (max-width: 1459px) {
  .Aboute_texts__dJO0u {
    width: 400px;
  }
}
@media screen and (max-width: 1335px) {
  .Aboute_texts__dJO0u {
    width: 300px;
  }
}
@media screen and (max-width: 480px) {
  .Aboute_header__zXOM0, .Aboute_paragraph__x6NEY {
    margin-top: 100px;
    margin-bottom: 50px;
  }
  .Aboute_goals__On1aT {
    margin-top: 100px;
    margin-bottom: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Aboute/Aboute.module.scss"],"names":[],"mappings":"AAcA;EACE,WAAA;AAbF;;AAiBA;EACE,WAAA;EAEA,yBAAA;AAfF;;AAuBA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AApBF;;AAyBA;EACE,UAAA;EAEA,yBAAA;EACA,YAAA;AAvBF;;AA4BA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;EACA,iBAAA;EACA,oBAAA;AAzBF;;AA6BA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;AA1BF;;AA6BA;EAGE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AA5BF;;AAkCA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qDAAA;AA/BF;;AAmCA;;;EAIE,mDAAA;EACA,qBAAA;AAjCF;;AAqCA;EACE,cAAA;EACA,eAAA;AAlCF;;AAsCA;EACE,cAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EAEA,UAAA;EACA,gBAAA;AApCF;;AAwCA;EACE,WAAA;EACA,iBAAA;AArCF;;AA0CA;EACE,eAAA;EACA,gBAAA;EAEA,YAAA;EACA,iCAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,gBAAA;EAEA,YAAA;EACA,iCAAA;AAzCF;;AA4CA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,iCAAA;EACA,mBAAA;AAzCF;;AA6CA;EAGE,iBAAA;EACA,aAAA;EACA,eAAA;AA5CF;;AAkDA;EACE,YAAA;EACA,aAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;AA/CF;;AAkDA;EACE,gBAAA;EAEA,oBAAA;AAhDF;;AAsDA;EACE,oBAAA;AAnDF;;AAsDA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EAEA,mBAAA;EACA,iCAAA;AApDF;;AAwDA;EACE,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EAGA,iCAAA;AAvDF;;AA0DA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAvDF;;AA0DA;EACE,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;EACA,mBAAA;AAvDF;;AA4DA;EACE;IACE,UAAA;EAzDF;EA4DA;;IAEE,UAAA;EA1DF;EA6DA;IACE,UAAA;IACA,aAAA;EA3DF;EA8DA;IACE,UAAA;EA5DF;EA8DA;IACE,eAAA;EA5DF;EA+DA;IACE,eAAA;EA7DF;EA+DA;IACE,eAAA;EA7DF;EAgEA;IACE,eAAA;EA9DF;EAiEA;IACE,eAAA;EA/DF;AACF;AAkEA;EACE;IACE,YAAA;EAhEF;AACF;AAqEA;EACE;IACE,YAAA;EAnEF;AACF;AAsEA;EACE;IACE,YAAA;EApEF;AACF;AAgFA;EACE;IACE,iBAAA;IACA,mBAAA;EA9EF;EAiFA;IACE,iBAAA;IACA,oBAAA;EA/EF;AACF","sourcesContent":["body{\n\n}\n\n//.bg{\n//  width: 100%;\n//  height: 200vh;\n//  background-image: url(\"../Images/about 9.svg\");\n//  background-size: contain;\n//  background-repeat: no-repeat;\n//  background: red;\n//}\n\n\n.abooute {\n  width: 100%;\n\n}\n\n.aboute-section {\n  width: 100%;\n  //height: auto;\n  background-color: #1e1e1e;\n\n\n\n\n\n}\n\n.bg{\n  width: 100%;\n  height: 230vh ;\n  opacity: 0.3;\n  position: absolute;\n  background-image: url(\"../Images/about 9.svg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  //background-position-y: -150px;\n}\n\n\n.aboute-container {\n  width: 80%;\n  //height: 100vh;\n  background-color: #1e1e1e;\n  margin: auto;\n\n\n}\n\n.header {\n  font-size: 96px;\n  font-weight: 700;\n  line-height: 100%;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n  margin-top: 200px;\n  margin-bottom: 200px;\n\n}\n\n.paragraph {\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 100%;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n}\n\n.childs-sections {\n  //width: 80%;\n  //  height: 50vh;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: center;\n\n    //text-align: justify;\n    //background-color: red;\n}\n\n.childs-sections div {\n  width: 400px;\n  height: 182px;\n  background-color: white;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 25px;\n  border-radius: 16px;\n  transition: transform 1.2s ease, box-shadow 1.2s ease;\n\n}\n\n.childs-sections div:hover,\n.childs-sections div:focus,\n.childs-sections div:active {\n  //box-shadow: 2px 2px 2.2px silver;\n  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);\n  transform: scale(1.2);\n\n}\n\n.childs-sections div p:hover {\n  color: #191A1A;\n  cursor: pointer;\n\n}\n\n.childs-sections div p {\n  color: #4C6D59;\n  font-family: 'Roboto', sans-serif;\n  font-size: 20px;\n  line-height: 100%;\n  //text-align: justify;\n  width: 90%;\n  font-weight: 500;\n}\n\n\n.paragraphs-section {\n  width: 100%;\n  margin-top: 150px;\n  //height: 100%;\n\n}\n\n.paragraphs-section h6 {\n  font-size: 32px;\n  font-weight: 700;\n  //line-height: 100%;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n}\n\n.paragraphs-section h2 {\n  font-size: 32px;\n  font-weight: 500;\n  //line-height: 100%;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n}\n\n.paragraphs-section p {\n  font-size: clamp(23px, 6vw, 22px);\n  font-weight: 500;\n  line-height: 1.2;\n  color: white;\n  width: 50%;\n  font-family: 'Roboto', sans-serif;\n  text-align: justify;\n}\n\n\n.goals {\n  //height: 50vh;\n  //background-color: red;\n  margin-top: 200px;\n  display: flex;\n  flex-wrap: wrap;\n  //justify-content: space-around;\n  //align-items: start;\n\n}\n\n.img {\n  width: 512px;\n  height: 423px;\n  background-image: url(\"https://i.imgur.com/S0Ar7tC.jpeg\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.texts {\n  max-width: 820px;\n  //margin-left: 150px;\n  margin-bottom: 110px;\n\n\n  //height: 100%;\n}\n\n.texts-two {\n  margin-bottom: 100px;\n}\n\n.texts h2 {\n  color: white;\n  font-weight: 500;\n  font-size: 32px;\n  //line-height: 100%/\n  margin-bottom: 40px;\n  font-family: 'Roboto', sans-serif;\n\n}\n\n.texts p {\n  color: white;\n  font-weight: 400;\n  font-size: clamp(23px, 6vw, 22px);\n  text-align: justify;\n\n  //line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.texts-two h2 {\n  color: white;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.texts-two p {\n  color: white;\n  font-weight: 500;\n  font-size: clamp(22px, 6vw, 22px);\n  line-height: 1.4;\n  font-family: 'Roboto', sans-serif;\n  width: 50%;\n  text-align: justify;\n\n}\n\n\n@media screen and (max-width: 768px) {\n  .childs-sections div {\n    width: 90%;\n  }\n\n  .paragraphs-section p,\n  .texts-two p {\n    width: 90%;\n  }\n\n  .img {\n    width: 90%;\n    height: 250px;\n  }\n\n  .texts {\n    width: 90%;\n  }\n  .header {\n    font-size: 42px;\n  }\n\n  .paragraph {\n    font-size: 32px;\n  }\n  .paragraphs-section p {\n    font-size: 18px;\n\n  }\n  .texts p {\n    font-size: 18px;\n\n  }\n  .texts-two p {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 1586px) {\n  .texts {\n    width: 500px;\n  }\n\n\n}\n\n@media screen and (max-width: 1459px) {\n  .texts {\n    width: 400px;\n  }\n}\n\n@media screen and (max-width: 1335px) {\n  .texts {\n    width: 300px;\n  }\n\n\n}\n\n@media screen and (max-width: 1215px) {\n  .texts {\n    //width: 300px;\n    //margin-left: 20px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .header, .paragraph {\n    margin-top: 100px;\n    margin-bottom: 50px;\n  }\n\n  .goals {\n    margin-top: 100px;\n    margin-bottom: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"abooute": `Aboute_abooute__8Kayc`,
	"aboute-section": `Aboute_aboute-section__8ewhH`,
	"bg": `Aboute_bg__rstTK`,
	"aboute-container": `Aboute_aboute-container__UDnOj`,
	"header": `Aboute_header__zXOM0`,
	"paragraph": `Aboute_paragraph__x6NEY`,
	"childs-sections": `Aboute_childs-sections__XB35c`,
	"paragraphs-section": `Aboute_paragraphs-section__62vxi`,
	"goals": `Aboute_goals__On1aT`,
	"img": `Aboute_img__KQmE6`,
	"texts": `Aboute_texts__dJO0u`,
	"texts-two": `Aboute_texts-two__OX7hW`
};
export default ___CSS_LOADER_EXPORT___;
